import { PublikationSucheComponent } from './publikation-suche/publikation-suche.component';
import { Routes } from '@angular/router';
import { PublikationListComponent } from './publikation-list/publikation-list.component';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import { ErweiterungConfigResponse } from '../../core/base-api';
import { GbpublikationService } from '../../core/gb-api';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const PublikationRoutes: Routes = [
  {
    path: 'publikation',
    loadChildren: () => routes,
    providers: [GbpublikationService]
  }
];

const routes: Routes = [
  {
    path: '',
    component: PublikationSucheComponent,
    canActivate: [canActivateErweiterung],
    data: {
      erweiterung: [ActiveErweiterungenEnum.PUBLIKATION_CAPWEB],
      breadcrumb: 'publikation.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list',
    component: PublikationListComponent,
    canActivate: [canActivateErweiterung],
    data: {
      erweiterung: [ActiveErweiterungenEnum.PUBLIKATION_CAPWEB],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    }
  }
];
